import { useEffect, useState } from 'react'

import { useNotifications } from 'app/application/application'
import { Notification as NotificationType } from 'app/application/types'

import Notification from './Notification'
import styles from './Notifications.module.scss'

export type UINotification = {
  removeAt?: number | undefined
  shown: boolean
} & NotificationType

const determineRemoveTime = (uiNotification: UINotification, nextShownState: boolean) => {
  if (uiNotification.removeAt) {
    return uiNotification.removeAt
  }
  if (uiNotification.shown && !nextShownState) {
    return new Date().getTime() + 300
  }

  return undefined
}

const Notifications = () => {
  const { deleteNotification, notifications } = useNotifications()

  const [uiNotifications, setUiNotifications] = useState<UINotification[]>([])

  useEffect(() => {
    setUiNotifications((prev) => {
      const updatedUiNotifications: UINotification[] = prev
        .filter(
          (uiNotification) =>
            !uiNotification.removeAt || new Date().getTime() < uiNotification.removeAt,
        )
        .map((uiNotification) => {
          const nextShownState = notifications.some(
            (notification) => notification.uuid === uiNotification.uuid,
          )
          return {
            ...uiNotification,
            removeAt: determineRemoveTime(uiNotification, nextShownState),
            shown: nextShownState,
          }
        })

      notifications.forEach((notification) => {
        if (!prev.some((uiNotification) => uiNotification.uuid === notification.uuid)) {
          updatedUiNotifications.push({ ...notification, shown: true })
        }
      })

      return updatedUiNotifications
    })
  }, [notifications])

  return (
    <div className={styles.notifications}>
      {uiNotifications.map((uiNotification) => (
        <Notification
          key={uiNotification.uuid}
          notification={uiNotification}
          onClose={() => deleteNotification(uiNotification)}
        />
      ))}
    </div>
  )
}

export default Notifications
